import { render, staticRenderFns } from "./PconEdit.vue?vue&type=template&id=04bc0502&scoped=true&"
import script from "./PconEdit.vue?vue&type=script&lang=js&"
export * from "./PconEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bc0502",
  null
  
)

export default component.exports